import { connect } from 'react-redux';
import LaporanJenisPekerjaan from '../../views/Settings/LaporanJenisPekerjaan.view';
import {
  getParamOptionsAcademics, getClassesOptions, getPeriodsOptions, getPrmLevels, getSchoolUnitsOptions, getParamPerwakilan,
} from '../../states/thunks/options.thunk';
import {studentCount, reportTtlPosition, reportTtlPositionPerwakilan,
  reportTtlPositionPerunit
} from '../../states/thunks/academics.thunk';


function mapStateToProps(state) {
  return {
    classes: state.options.classes,
    levels: state.options.levels,
    user: state.user || {},

  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleStudentCount: payload => dispatch(studentCount(payload)),
    getClassesOptions: payload => dispatch(getClassesOptions(payload)),
    getParamOptionsAcademics: (payload, type) => dispatch(getParamOptionsAcademics(payload, type)),
    handleReportTtlPosition: (payload, goback) => dispatch(reportTtlPosition(payload, goback)),
    handleReportTtlPositionPerwakilan: (payload, goback) => dispatch(reportTtlPositionPerwakilan(payload, goback)),
    handleReportTtlPositionPerunit: (payload, goback) => dispatch(reportTtlPositionPerunit(payload, goback)),
    getPeriodsOptions: payload => dispatch(getPeriodsOptions(payload)),
    getPrmLevels: payload => dispatch(getPrmLevels(payload)),
    getSchoolUnitsOptions: payload => dispatch(getSchoolUnitsOptions(payload)),
    getParamPerwakilan: payload => dispatch(getParamPerwakilan(payload)),

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LaporanJenisPekerjaan);
